/**
 * Computes SHA-256 hex digest of input text using Web Crypto API.
 * @param {string} text - Input to hash
 * @returns {Promise<string>} Hex-encoded SHA-256 hash
 */
const sha256Hex = async (text) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
};

/**
 * Generates SHA-256 signature for SAT refresh-token API.
 * Format: SHA-256(`${memberId}${timestamp}${secret}`).
 * @param {string|number} memberId - Member identifier
 * @param {string} [timestamp] - Epoch ms string; defaults to Date.now().toString()
 * @returns {Promise<string>} Hex-encoded signature
 */
export const generateTokenApiSignature = async (memberId, timestamp) => {
  const ts = timestamp || Date.now().toString();
  const secretKey = process.env.REACT_APP_SAT_SECRET || "";
  const rawString = `${memberId}${ts}${secretKey}`;
  return sha256Hex(rawString);
};
